import type { NotificationTemplate, UpdateTemplateRequest } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export async function updateTemplate(
  workspaceSlug: string,
  templateId: string,
  request: UpdateTemplateRequest,
): Promise<NotificationTemplate> {
  const response = await AuthAxios.put<NotificationTemplate>(
    `/api/v1.0/e/${workspaceSlug}/notification-templates/${templateId}`,
    request,
  )
  return response.data
}
